import { translate } from 'react-switch-lang';
import { useCallback, useEffect, useState } from 'react';
import { FormGroup } from 'reactstrap';
import { useHttpClient } from '../../../../../security/hooks/axiosProvider';
import { unit as unitModel } from '../../../model/types';

const DetailUnit = (props) => {
  const [unit, setUnit] = useState(unitModel);
  const httpClient = useHttpClient(true);

  const getUnit = useCallback(async () => {
    if (props.unit.id !== undefined) {
      httpClient.current?.get(`/api/unit/${props.unit.id}`).then((response) => {
        setUnit(response.data);
      });
    }
  }, [httpClient, props.unit.id]);

  useEffect(() => {
    getUnit();
  }, [getUnit]);

  return (
    <>
      <form className="needs-validation" noValidate>
        <FormGroup className="form-row">
          <label htmlFor={'unit_name'}>{props.t('unit_name')}</label>
          <input type="text" className="form-control" name="name" id="unit_name" value={unit.name} disabled />
        </FormGroup>
        <FormGroup className="form-row">
          <label htmlFor="unit_description">{props.t('Description')}</label>
          <textarea value={unit.description} className="form-control" id="unit_description" rows={3} disabled />
        </FormGroup>
        <FormGroup className="form-row">
          <label htmlFor="unit_value">{props.t('unit_value')}</label>
          <input type="text" className="form-control" name="value" id="unit_value" value={unit.value} disabled />
        </FormGroup>
      </form>
    </>
  );
};
export default translate(DetailUnit);
